import React, {useState} from 'react'
// import {toast} from 'react-toastify'
// import Spinner from 'layout/common/Spinner'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {KTSVG} from 'helpers'
import {IItmesConfig} from 'models/GenericForm'
import OnBoardingFormComponent from './OnBoardingFormComponent'
import {getDateWithTimeForDisplay} from 'utils/helpers/getDate'
import {IFormField} from 'models/Common'
// import {ILogin} from 'models/Auth'

type IProps = {
 accessDetails: IFormField
 userId: string
 parentItemConfig?: IItmesConfig
 loader: boolean
 setLoader: (newState: boolean) => void
 reloadTabs: () => void
}

const BasicProfile = (props: IProps) => {
 const {t} = useTranslation()
 const [isDisabled, setIsDisabled] = useState(true)

 const handleEditBtnClick = () => {
  if (props.accessDetails?.basicDetails?.canEdit)
   setIsDisabled(false)
 }

 return (
  <div className='w-full'>
   {isDisabled && (
    <div className='w-full mb-3'>
     <div className='flex items-center justify-end'>
      <Button
       disabled={
        !props.accessDetails?.basicDetails?.canEdit
       }
       onClick={handleEditBtnClick}
       color='blue'
       className='text-center py-[9px] pr-6 pl-4 bg-white 
                     !rounded-lg text-base !text-[#4E83E4] font-semibold border-[#4E83E4]'
      >
       <KTSVG
        path={`/media/icons/pencil.svg`}
        svgClassName={`w-4 h-4 text-white p-[2px]`}
       />
       {t('myAccountPage.edit')}
      </Button>
     </div>
    </div>
   )}
   <OnBoardingFormComponent
    userId={props.userId}
    parentItemConfig={props.parentItemConfig}
    loader={props.loader}
    isDisabled={isDisabled}
    setIsDisabled={setIsDisabled}
    setLoader={props.setLoader}
    reloadTabs={props.reloadTabs}
    className='grid md:grid-cols-3 gap-5 w-full mt-4'
   />
   <div className='w-full mt-10'>
    <div className='flex items-center '>
     <KTSVG
      path={`/media/icons/reload.svg`}
      svgClassName={`w-[34px] h-[34px] bg-[#1A73E8] text-white rounded-full p-[2px]`}
     />
     <div className='text-[#33393D] text-lg font-medium ml-2'>
      {t('myAccountPage.lastActiveOn')}
     </div>
     <div className='text-[#80868C] text-sm font-medium ml-6'>
      {props.parentItemConfig &&
       getDateWithTimeForDisplay(
        props.parentItemConfig?.updated_at
       )}
     </div>
    </div>
   </div>
  </div>
 )
}

export default BasicProfile
